import KetentuanPengembalianDanaID from "components/ketentuan-pengembalian-dana/ketentuan-pengembalian-dana-id";
import React from "react";
import { KetentuanPengembalianDanaSEO } from "seo/kebijakan-privasi.seo";
import { Container } from "styles/common/container";
import {
  PrivacyPolicyContent,
  PrivacyPolicyContentContainer,
  PrivacyPolicyPageTitle,
  PrivacyPolicyPageTitleWrapper,
  RefundPolicyHeaderContainer
} from "styles/pages/kebijakan-privasi.styles";
import MoneyBackGuarantee from "public/assets/refund-policy/money-back-guarante.png";
import Image from "next/legacy/image";
import { useMediaQuery } from "hooks/use-media-query/use-media-query";

const KetentuanPengembalianDana: React.FC = () => {
  const isMobile = useMediaQuery("mobile");

  return (
    <main>
      <KetentuanPengembalianDanaSEO />
      <PrivacyPolicyPageTitleWrapper>
        <Container>
          <RefundPolicyHeaderContainer>
            <PrivacyPolicyPageTitle>
              Panduan Pengajuan Klaim Garansi Uang Kembali 100%
            </PrivacyPolicyPageTitle>
            {!isMobile && (
              <Image
                src={MoneyBackGuarantee}
                alt="Money Back Guarantee"
                width={267}
                height={234}
              />
            )}
          </RefundPolicyHeaderContainer>
        </Container>
      </PrivacyPolicyPageTitleWrapper>
      <PrivacyPolicyContentContainer>
        <PrivacyPolicyContent>
          <KetentuanPengembalianDanaID />
        </PrivacyPolicyContent>
      </PrivacyPolicyContentContainer>
    </main>
  );
};

export default KetentuanPengembalianDana;
